import SdAnalyticsScreen from './SdAnalyticsScreen';

export default SdAnalyticsScreen;
